<template>
	<div class="container">
		<mt-button plain @click="close()" class='close'>
            <img src="../../../assets/image/invite_friends/close-button.svg" height="35" width="35" slot="icon">
        </mt-button>
		<div class="section">
			<div class="header">
				<h1>
					{{ i18n.t('invite_friends.invite_friends_and_registered') }}<br />{{
						i18n.t('invite_friends.get_gcoin_now', { coin })
					}}
				</h1>
			</div>
			<div class="content">
				<div class="title">
					<h1>{{ i18n.t('invite_friends.share_my_invitation_code') }}</h1>
				</div>
				<div class="form-group">
					<mt-field
						v-model="invitationCode"
						readonly
						disableClear
						class="copy-field"
					>
						<input type="button" class="copy-button" @click="copy()" />
					</mt-field>
				</div>
				<div class="form-group">{{ i18n.t('general.or') }}</div>
				<div class="form-group">
					<mt-button class="btn-bg" @click="share()">{{
						i18n.t('invite_friends.share_my_invitation_code_by_app')
					}}</mt-button>
				</div>
                <div class="form-group has-been-invited" v-if="hasInviter || !deviceIdValid">
                    {{ i18n.t('invite_friends.device_has_been_invited') }}
                </div>
				<div class="form-group" v-else-if="!hasInviter && deviceIdValid && !inputInvitationCodeFieldVisible">
					<mt-button plain @click="inputInvitationCode()">{{
						i18n.t('invite_friends.input_friend_invitation_code')
					}}</mt-button>
				</div>
				<div class="form-group" v-else-if="!hasInviter && deviceIdValid && inputInvitationCodeFieldVisible">
					<mt-field
						v-model="friendInvitationCode"
						class="copy-field"
						:placeholder="i18n.t('invite_friends.input_friend_invitation_code')"
					>
						<mt-button plain @click="submitFriendInvitationCode()" :disabled="this.$v.$invalid">{{
							i18n.t('general.confirm')
						}}</mt-button>
					</mt-field>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import i18n from '@/i18n'
import router from '@/router'
import { checkDeviceIdValid, updateInviter } from '@/api/member'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'

export default {
	name: 'InviteFriends',
	validations: {
		friendInvitationCode: {
			required,
			minLength: minLength(10),
			maxLength: maxLength(10)
		}
	},
	data () {
		return {
			i18n,
			coin: 500,
			inputInvitationCodeFieldVisible: false,
			deviceIdValid: false,
			friendInvitationCode: ''
		}
	},
	mounted () {
		this.checkDeviceIdValid(this.deviceId).then((res) => {
			if (res.code !== 10000) {
				this.deviceIdValid = false
			} else {
				this.deviceIdValid = true
			}
		})

		this.friendInvitationCode = store.state.member.friend_invitation_code

		if (this.friendInvitationCode) {
			this.inputInvitationCodeFieldVisible = true
		}
	},
	computed: {
		deviceId: function () {
			return store.state.member.deviceId
		},
		invitationCode: function () {
			return store.state.member.info.invitation_code
		},
		hasInviter: function () {
			return store.state.member.info.inviter_id !== null && store.state.member.info.inviter_id !== 0
		},
		shareMessageTemplates: function () {
			return store.state.config.config.app_share_message_templates
		},
		shareMessage: function () {
			const url = router
				.resolve({
					name: 'Startapp',
					query: {
						redirect: 'MemberIndex',
						invitationCode: this.invitationCode
					}
				})
				.href.slice(1)
			return this.shareMessageTemplates
				.find((t) => t.code === 'app_share')
				.content.replace(':url', `${process.env.VUE_APP_H5_HOST}/${url}`)
		}
	},
	methods: {
		checkDeviceIdValid,
		updateInviter,
		close () {
			store.dispatch('closeInviteFriendsModal')
		},
		copy () {
			this.$copyText(this.invitationCode).then(
				() => {
					this.$alert.success(i18n.t('share.copy_successful'))
				},
				(e) => {
					this.$alert.error(i18n.t('share.copy_manual'))
				}
			)
		},
		share () {
			if (window.nativePostMessage) {
				window.nativePostMessage({
					type: 'share',
					content: {
						title: i18n.t('invite_friends.share_my_invitation_code'),
						message: this.shareMessage
					}
				})
			}
		},
		inputInvitationCode () {
			this.inputInvitationCodeFieldVisible = true
		},
		submitFriendInvitationCode () {
			this.updateInviter(this.friendInvitationCode, this.deviceId)
				.then((res) => {
					this.$alert.success(
						i18n.t('invite_friends.update_inviter_successful')
					)
					this.inputInvitationCodeFieldVisible = false
					store.commit('memberEdit', {
						inviter_id: res.result.inviter_id
					})
					store.commit('setFriendInvitationCode', undefined)
					this.close()
				}).catch((err) => this.$alert.error(`${i18n.t('invite_friends.update_inviter_failed')}: ${err.message}`))
		}
	}
}
</script>

<style scoped>
>>> .mint-field-core {
	text-align: center;
}
</style>

<style lang='scss' scoped>
.container {
	position: relative;
	height: inherit;
	width: inherit;
	border-radius: 35px;
	background: url('../../../assets/image/invite_friends/background.png')
		no-repeat;
	background-size: cover;
	.close {
		position: absolute;
		right: 5%;
		top: 3%;
	}
	.section {
		position: relative;
		display: flex;
		flex-direction: column;
		top: 8%;
		padding: 1rem;
		text-align: center;
		height: 85%;
	}
	.section .header {
		flex: 1;
		color: white;
		font-weight: bold;
		font-size: 1.2rem;
		text-shadow: black 0.1em 0.1em 0.2em;
	}
	.section .content {
		margin-top: 2%;
		flex: 1;
		color: black;
	}
	.content .title {
		color: black;
		font-weight: bold;
		font-size: 1rem;
		letter-spacing: 3px;
	}

	.btn-bg {
		background: url('../../../assets/image/invite_friends/button-background.png')
			no-repeat center;
		height: 2rem;
		width: auto;
		border-radius: 20px;
		color: white;
	}

	.close-btn {
		border: none;
	}

	.is-plain {
		border: none;
	}

    .has-been-invited {
        color: #525252;
        font-size: 0.8rem;
    }
}
.copy-field {
	width: 70%;
	border-radius: 15px;
	margin: 0 auto;
}

.copy-button {
	background: url('../../../assets/image/invite_friends/copy-button.svg')
		no-repeat center;
	height: 35px;
	width: 35px;
}

.form-group {
	margin: 0.7rem 0;
}
</style>
